import AniLink from "gatsby-plugin-transition-link/AniLink"
import logo from "../assets/css/images/logo.png"
import Menu from "./menu"

import PropTypes from "prop-types"
import React from "react"

const Header = () => (
  <div id="header">
    <div id="header-one">
      <AniLink fade id="logo" to="/" title="mihaidoru.ro">
        <img src={logo} alt="mihaidoru.ro" />
      </AniLink>
      <div id="social">
        <a
          id="fb"
          href="http://www.facebook.com/mihaidoru.ro"
          target="_blank"
          rel="noopener noreferrer"
        >
          facebook
        </a>
        <a
          id="tw"
          href="https://twitter.com/mihaidoru"
          target="_blank"
          rel="noopener noreferrer"
        >
          twitter
        </a>
        <a
          id="in"
          href="http://www.linkedin.com/in/mihaidoru"
          target="_blank"
          rel="noopener noreferrer"
        >
          linkedin
        </a>
      </div>
    </div>
    <div id="header-two">
      <div id="main-menu">
        <div className="menu-main-menu-container">
          <Menu menuId="menu" />
        </div>
      </div>
      <form id="search" action="index.html">
        <input name="s" className="text" type="text" placeholder="search..." />
        <input className="caut" type="submit" value="" />
      </form>
    </div>
    <h2 id="header-three" className="page-title">
      people management in software development
    </h2>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
